@if (showEnrollmentReport) {
    <app-enrollment-report></app-enrollment-report>
}
@if (showCapacityReport) {
    <app-capacity-report></app-capacity-report>
}
@if (showTransactionReport) {
    <app-transaction-report></app-transaction-report>
}
